module.exports = __webpack_public_path__ + "static/media/gongcheng2.841078db.png";